import { connect } from 'react-redux';
import PoliticaContaDigitalList from './politicaContaDigitalList';

export default connect()(PoliticaContaDigitalList);
